<template>

    <div class="template-selector-first-level">

        <div v-if="hasRecentlyUsedTemplates" class="row mt-3">
            <!-- first column-->
            <div class="col-12 col-lg-6 no-padding">
                <hr class="mt-0 mb-0 border-none taller-hr">
            </div>

            <div class="col-xs-none col-lg-6">
            </div>
        </div>

        <div class="row" v-bind:class="{ 'mt-3': !hasRecentlyUsedTemplates}">
            <!-- first column-->
            <div class="col-12 col-lg">

                <div v-if="hasRecentlyUsedTemplates">

                    <div class="row mt-2">
                        <div class="col">
                            <span class="badge bg-portal-secondary-green text-white p-1" v-once>{{cmsContentBlocks['templateSelector.MainPage.RecentlyUsedBadgeText']}}</span>
                        </div>
                    </div>

                    <div class="row mt-2" v-for="recentTemplateId in recentlyUsedTemplates">
                        <div class="col">
                            <template-record-link :template-record="findTemplateById(recentTemplateId, templateRecordReferenceData).template"
                                                  :title-to-output="recentTemplateTitleOutput(recentTemplateId)"
                                                  @itemSelected="templateClicked" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col no-padding">
                            <hr class="border-none taller-hr">
                        </div>
                    </div>

                </div>

                <div v-if="!hasRecentlyUsedTemplates" class="row">
                    <div class="col no-padding">
                        <hr class="no-padding d-block d-lg-none" />
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <p class="section-header h6" v-once>{{cmsContentBlocks['templateSelector.MainPage.DoctorsOfficeHeader']}}</p>
                    </div>

                    <div class="col-auto my-auto d-inline d-lg-none">
                        <a class="collapsed" data-toggle="collapse" role="button" href="#DoctorsOfficeSection" aria-expanded="false">
                            <span class="show-on-collapsed">
                                <i class="fa fa-plus" aria-hidden="true" aria-label="Show more"></i>
                            </span>
                            <span class="show-on-expanded">
                                <i class="fa fa-minus" aria-hidden="true" aria-label="Show less"></i>
                            </span>
                        </a>
                    </div>
                </div>

                <div id="DoctorsOfficeSection" class="collapse-override-lg collapse hide" role="tabpanel">
                    <div class="row" v-for="template in doctorsOfficeTemplates">
                        <div class="col mt-2">
                            <template-record-link :template-record="template"
                                                  :title-to-output="template.title"
                                                  @itemSelected="templateClicked" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col no-padding">
                        <hr class="no-padding d-block d-lg-none" />
                    </div>
                </div>

            </div>
            <!-- end of first column-->
            <!-- second column-->
            <div class="col-12 col-lg">

                <div class="row">
                    <div class="col">
                        <p class="section-header h6" v-once>{{cmsContentBlocks['templateSelector.MainPage.DepartmentHeader']}}</p>
                    </div>

                    <div class="col-auto my-auto d-inline d-lg-none">
                        <a class="collapsed" data-toggle="collapse" role="button" href="#DepartmentSection" aria-expanded="false">
                            <span class="show-on-collapsed">
                                <i class="fa fa-plus" aria-hidden="true" aria-label="Show more"></i>
                            </span>
                            <span class="show-on-expanded">
                                <i class="fa fa-minus" aria-hidden="true" aria-label="Show less"></i>
                            </span>
                        </a>
                    </div>
                </div>

                <div id="DepartmentSection" class="collapse-override-lg collapse hide" role="tabpanel">
                    <div class="row " v-for="template in departmenTemplates">
                        <div class="col mt-2">
                            <template-record-link :template-record="template"
                                                  :title-to-output="template.title"
                                                  @itemSelected="templateClicked" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col no-padding">
                        <hr class="no-padding d-block d-lg-none" />
                    </div>
                </div>

                <div class="row mt-lg-4">
                    <div class="col">
                        <p class="section-header h6" v-once>{{cmsContentBlocks['templateSelector.MainPage.HealthCareTeamHeader']}}</p>
                    </div>
                    <div class="col-auto my-auto d-inline d-lg-none">
                        <a class="collapsed" data-toggle="collapse" role="button" href="#HealthCareTeamSection" aria-expanded="false">
                            <span class="show-on-collapsed">
                                <i class="fa fa-plus" aria-hidden="true" aria-label="Show more"></i>
                            </span>
                            <span class="show-on-expanded">
                                <i class="fa fa-minus" aria-hidden="true" aria-label="Show less"></i>
                            </span>
                        </a>
                    </div>
                </div>

                <div id="HealthCareTeamSection" class="collapse-override-lg collapse hide" role="tabpanel">
                    <div class="row" v-for="template in healthCareTeamTemplates">
                        <div class="col mt-2">
                            <template-record-link :template-record="template"
                                                  :title-to-output="template.title"
                                                  @itemSelected="templateClicked" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col no-padding">
                        <hr class="no-padding d-block d-lg-none" />
                    </div>
                </div>

            </div>
            <!-- end of second column-->
        </div>

    </div>

</template>

<script>

    import Vue from 'vue';
    import templateRecordLink from './template.selector.link.record.vue';
    import jlinq from '@SharedServices/linq.javascript.service.js';
    import { findTemplateByTemplateId } from '../../message.service';

    export default {
        name: 'templateRecordSelectorFirstLevel',
        props: {
            templateRecordReferenceData: { type: Array },

            //{ department: ..., template: ...}
            recentlyUsedTemplates: { type: Array },

            cmsContentBlocks: {}
        },
        components: {
            'template-record-link': templateRecordLink
        },
        computed: {

            hasRecentlyUsedTemplates: function () {
                return this.recentlyUsedTemplates && this.recentlyUsedTemplates.length > 0;
            },

            doctorsOfficeTemplates: function () {
                return this.templateRecordReferenceData.filter(x => x.group == 'DoctorsOffice');
            },

            healthCareTeamTemplates: function () {
                return this.templateRecordReferenceData.filter(x => x.group == 'HealthCareTeam');
            },

            departmenTemplates: function () {
                return this.templateRecordReferenceData.filter(x => x.group == 'Department');
            }
        },
        methods: {

            templateClicked: function (template) {
                this.$emit('templateClicked', template);
            },

            findTemplateById(recentRecordId) {
                return findTemplateByTemplateId(recentRecordId, this.templateRecordReferenceData);
            },

            recentTemplateTitleOutput(recentRecordId) {
                let foundTemplate = this.findTemplateById(recentRecordId, this.templateRecordReferenceData);

                if (foundTemplate.parentTemplate == null) {
                    return foundTemplate.template.title;
                }

                return foundTemplate.parentTemplate.title + ' - ' + foundTemplate.template.title;
            }

        }
    };
</script>

